import React, { ReactNode } from 'react';
import { isEmpty } from 'lodash';
import { TableCell, TableHead, TableRow, TableBody } from '@mui/material';
import { TableRows } from './TableRows';

export type TableSectionProps = {
  title?: string;
  valueText?: string;
  emptyComponent?: string;
  children?: ReactNode;
};

const TableSection = ({ children, title, valueText, emptyComponent }: TableSectionProps) => {
  if (isEmpty(children) && !emptyComponent) {
    return null;
  }

  const header =
    title || valueText ? (
      <TableRow>
        <TableCell>{title}</TableCell>
        <TableCell>{valueText}</TableCell>
      </TableRow>
    ) : null;

  const rows = <TableRows emptyComponent={emptyComponent}>{children}</TableRows>;

  return header || rows ? (
    <>
      {header ? <TableHead>{header}</TableHead> : null}
      {rows ? <TableBody>{rows}</TableBody> : null}
    </>
  ) : null;
};

export { TableSection };
